import { useEffect } from 'react';

import { CONSTANTS } from 'services';

const { breakpointMobile } = CONSTANTS;

const useMobileLayout = (toggleMobileLayout) => {
  useEffect(() => {
    window.addEventListener('resize', () => {
      const viewportWidth = window.innerWidth;
      if (viewportWidth < breakpointMobile) {
        toggleMobileLayout(true);
      }
      if (viewportWidth > breakpointMobile) {
        toggleMobileLayout(false);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useMobileLayout;
